// extracted by mini-css-extract-plugin
export var dropdownIcon = "_nj-6";
export var imgContainer = "_nj-3";
export var menuIcon = "_nj-5";
export var pillWrapper = "_nj-2";
export var pillsContainer = "_nj-1";
export var subscriptionCard = "_nj-0";
export var subscriptionLogo = "_nj-4";